import moment from 'moment';

export function imprimirReporte(
  nombreOrganismo,
  fechaGeneracion,
  fechaInicio,
  fechaFin,
  datos,
  montoTotal
) {
  var mywindow = window.open('', 'PRINT', 'height=800,width=600');
  mywindow.document.write('<html><head><title>Reporte</title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE VENTA EN UN RANGO DE FECHAS</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${nombreOrganismo}  </h3>`
  );
  mywindow.document.write(
    `<h3> Reporte para el rango de fechas de: ${fechaInicio} - ${fechaFin}  </h3>`
  );
  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Vendidos</th>
    <th>Sub Total</th>
  </tr>
  `);

  datos.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`<td> $ ${dato.subtotal} </td>`);
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write(
    `<p style="text-align:right; margin-top: 20px; margin-right: 35px"> Monto Total: $ ${montoTotal} </p>`
  );

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

// A CONTINUACION LA FUNCION PARA GENERAR EL REPORTE DE DEPOSITOS

export function imprimirReporteDepositos(
  nombreOrganismo,
  fechaGeneracion,
  fechaInicio,
  fechaFin,
  datos,
  montoTotal
) {
  var mywindow = window.open('', 'PRINT', 'height=800,width=600');
  mywindow.document.write('<html><head><title>Reporte</title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE DEPOSITOS EN UN RANGO DE FECHAS</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${nombreOrganismo}  </h3>`
  );

  mywindow.document.write(
    `<h3> Reporte para el rango de fechas de: ${fechaInicio} - ${fechaFin}  </h3>`
  );
  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Fecha del Deposito</th>
    <th>Sucursal B.P.N</th> 
    <th>Nro. Boleta Deposito</th>
    <th>Monto Depositado</th>
  </tr>
  `);

  datos.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.fecha} </td>`);
    mywindow.document.write(`<td> $ ${dato.sucursal} </td>`);
    mywindow.document.write(`<td> ${dato.numBoletaDeposito} </td>`);
    mywindow.document.write(`<td> $ ${dato.importe} </td>`);
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write(
    `<p style="text-align:right; margin-top: 20px; margin-right: 35px"> MONTO TOTAL DEPOSITADO EN EL PERIODO: <b> $ ${montoTotal} </b></p>`
  );

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

// A CONTINUACION LA FUNCION PARA GENERAR EL STOCK.

export function imprimirReporteStock(nombreOrganismo, fechaGeneracion, datos) {
  var mywindow = window.open('', 'PRINT', 'height=800,width=600');
  mywindow.document.write('<html><head><title>Reporte</title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE STOCK ACTUAL</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${nombreOrganismo}  </h3>`
  );

  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Stock</th>
  </tr>
  `);

  datos.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.tipo_sello.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.tipo_sello.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

export function imprimirReporteStockFecha(
  nombreOrganismo,
  fechaGeneracion,
  datos,
  fecha
) {
  var mywindow = window.open('', 'PRINT', 'height=800,width=600');
  mywindow.document.write('<html><head><title>Reporte</title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE STOCK DEL DIA ${fecha}</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${nombreOrganismo}  </h3>`
  );

  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Stock</th>
  </tr>
  `);

  datos.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.tipo_sello.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.tipo_sello.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

// IMPRIMIR UN REPORTE DE ENVIO DETERMINADO.

export function imprimirReporteEnvio(fechaGeneracion, dato) {
  // console.log("entre a imprimir envio");
  // console.log(dato);

  var mywindow = window.open('', 'PRINT', 'height=800,width=600');

  mywindow.document.write('<html><head><title>Reporte</title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  // mywindow.document.write(`
  // <link rel="stylesheet" type="text/css" href="./estiloImpresion.css">`);
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE UN ENVIO</ins></h3>`
  );

  mywindow.document.write(
    `<h3 style="margin-top: 40px"> Numero de envio: ${dato.numero} </h3>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Fecha de envio: ${moment(
      dato.fechaEnvio
    ).format('DD/MM/YYYY')} </h4>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Organismo Destino: ${
      dato.receptor.nombre
    }  </h4>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Detalles del envio:  </h4>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Cantidad</th>
    <th>N° Inicial</th>
    <th>N° Final</th>
  </tr>
  `);

  dato.detalle.forEach(detalle => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${detalle.tipo_sello.nombre} </td>`);
    mywindow.document.write(`<td> $ ${detalle.tipo_sello.valor} </td>`);
    mywindow.document.write(`<td> ${detalle.cantidad} </td>`);
    mywindow.document.write(`<td> ${detalle.numeracionInicial} </td>`);
    mywindow.document.write(`<td> ${detalle.numeracionFinal} </td>`);
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Importe total del envio: $ ${
      dato.importe
    }  </h3>`
  );

  mywindow.document.write(
    `<footer><h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5></footer>`
  );

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

export function imprimirDepositoContravencion(fechaGeneracion, dato) {
  // console.log("entre a imprimir envio");
  // console.log(dato);

  var mywindow = window.open('', 'PRINT', 'height=800,width=600');

  mywindow.document.write('<html><head><title>Deposito Contravencion</title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  // mywindow.document.write(`
  // <link rel="stylesheet" type="text/css" href="./estiloImpresion.css">`);
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> DEPOSITO CONTRAVENCION</ins></h3>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Organismo: ${dato.organismo.nombre}  </h4>`
  );

  mywindow.document.write(
    `<h3 style="margin-top: 40px"> Fecha de Creacion: ${moment(
      dato.fechaCreacion
    ).format('DD/MM/YYYY')} </h3>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Fecha de Deposito: ${moment(
      dato.fechaDeposito
    ).format('DD/MM/YYYY')} </h4>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Importe Depositado: ${dato.importe.toLocaleString(
      'es-AR',
      {
        style: 'currency',
        currency: 'ARS',
      }
    )} </h4>`
  );

  mywindow.document.write(
    `<h4 style="margin-top: 10px"> Detalles del Deposito:  </h4>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Recibo</th>
    <th>Importe</th> 
  </tr>
  `);

  dato.recibos.forEach(recibo => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${recibo.nombre} </td>`);
    mywindow.document.write(
      `<td> $ ${recibo.contraventor.sancion.monto.toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
      })} </td>`
    );
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write(
    `<footer><h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5></footer>`
  );

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

export function imprimirTraspaso(traspaso, fechaGeneracion) {
  var mywindow = window.open('', 'PRINT', 'height=800,width=600');
  mywindow.document.write('<html><head><title></title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE TRASPASO</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${
      traspaso.organismo.nombre
    }  </h3>`
  );

  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5>`
  );

  mywindow.document
    .write(`<table align="center" style="width:100%; margin: 0px auto;">
  <tr>
    <td>Organismo: </td>
    <td>${traspaso.organismo.nombre}</td>
  </tr>
  <tr>
    <td>Juez de paz saliente: </th>
    <td> <b>${traspaso.usuarioSaliente.apellido} ${
    traspaso.usuarioSaliente.nombre
  } </b> </th>
  </tr>
  <tr>
    <td>Juez de paz entrante: </th>
    <td> <b>${traspaso.usuarioEntrante.apellido} ${
    traspaso.usuarioEntrante.nombre
  } </b> </th>
  </tr>
  <tr>
    <td>Motivo del traspaso: </th>
    <td> <b>${traspaso.motivo}</b> </th>
  </tr>
  
  <tr>
    <td>Fecha estipulada del traspaso: </td>
    <td>${moment(traspaso.fechaEstimada).format('DD/MM/YYYY HH:mm')}</td>
  </tr>
  <tr>
    <td>Fecha de confirmación: </td>
    <td>${moment(traspaso.fechaReal).format('DD/MM/YYYY HH:mm')}</td>
  </tr>
  <tr>
    <td>Se deja constancia en la entrega: </td>
    <td>${traspaso.observacionEntrega}</td>
  </tr>
  <tr>
    <td>Se deja constancia en la recepción: </td>
    <td>${
      traspaso.observacionRecepcion ? traspaso.observacionRecepcion : '-'
    }</td>
  </tr>
</table>`);

  mywindow.document.write(`<br/>`);
  mywindow.document.write(`<br/>`);

  mywindow.document.write(
    `<h3 style="text-align: center"><ins> STOCK: </ins></h3>`
  );
  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Cantidad</th>
  </tr>
  `);

  traspaso.stock.detalle.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.tipo_sello.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.tipo_sello.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`</tr>`);
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write(`<br/>`);
  mywindow.document.write(`<br/>`);

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}

export function imprimirRendicion(
  stockDiaAnterior,
  ventasPeriodo,
  depositos,
  stockDiaSiguiente,
  ingresos,
  fechaGeneracion,
  fechaInicio,
  fechaFin,
  nombreOrganismo
) {
  var mywindow = window.open('', 'PRINT', 'height=800,width=600');
  mywindow.document.write('<html><head><title></title>');
  mywindow.document.write(
    `<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } 
    
    body {
      font-size: 10pt
    }
    table, th, td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    th, td {
      text-align: center;
  }
   } 
   </style>`
  );
  mywindow.document.write('</head><body >');
  mywindow.document.write('<div class="textoAImprimir">');

  mywindow.document.write(``);
  mywindow.document.write(
    `<h2 style="text-align: center"><ins> REPORTE DE RENDICION</ins></h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 30px"> Organismo: ${nombreOrganismo}  </h3>`
  );
  mywindow.document.write(
    `<h3 style="margin-top: 5px"> Reporte para el rango de fechas de: ${fechaInicio} - ${fechaFin}  </h3>`
  );

  mywindow.document.write(
    `<h5> Fecha de generacion del reporte: ${fechaGeneracion} </h5>`
  );

  mywindow.document.write(
    `<h3 style="text-align: center"><ins> SALDO DE TASAS AL DIA ANTERIOR: ${moment(
      fechaInicio,
      'DD/MM/YYYY'
    )
      .subtract(1, 'days')
      .format('DD/MM/YYYY')} </ins></h3>`
  );

  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Stock</th>
  </tr>
  `);

  let montoTotalDiaAnterior = 0;
  stockDiaAnterior.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.tipo_sello.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.tipo_sello.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`</tr>`);
    montoTotalDiaAnterior += dato.tipo_sello.valor * dato.cantidad;
  });
  mywindow.document.write(`</table>`);
  mywindow.document.write(
    `<h4 style="text-align: center">TOTAL: $${montoTotalDiaAnterior}</h4>`
  );

  mywindow.document.write(
    `<h3 style="text-align: center"><ins> VENTAS DEL RANGO DE FECHAS ${fechaInicio} - ${fechaFin} </ins></h3>`
  );
  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Cantidad</th>
    <th>Sub Total</th>
  </tr>
  `);

  let montoVentas = 0;
  ventasPeriodo.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`<td> $ ${dato.subtotal} </td>`);
    mywindow.document.write(`</tr>`);
    montoVentas += dato.subtotal;
  });
  mywindow.document.write(`</table>`);
  mywindow.document.write(
    `<h4 style="text-align: center">TOTAL: $${montoVentas}</h4>`
  );

  mywindow.document.write(
    `<h3 style="text-align: center"><ins> INGRESOS DE TASAS DEL PERIODO ${fechaInicio} - ${fechaFin}  </ins></h3>`
  );
  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Cantidad</th>
    <th>Sub Total</th>
  </tr>
  `);

  let montoIngresos = 0;
  ingresos.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`<td> $ ${dato.valor * dato.cantidad} </td>`);
    mywindow.document.write(`</tr>`);
    montoIngresos += dato.valor * dato.cantidad;
  });

  mywindow.document.write(`</table>`);
  mywindow.document.write(
    `<h4 style="text-align: center">TOTAL: $${montoIngresos}</h4>`
  );

  mywindow.document.write(
    `<h3 style="text-align: center"><ins> STOCK SIN VENDER: ${moment(
      fechaFin,
      'DD/MM/YYYY'
    )
      .add(1, 'days')
      .format('DD/MM/YYYY')} </ins></h3>`
  );
  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Tipo Sello</th>
    <th>Precio</th> 
    <th>Cantidad</th>
  </tr>
  `);

  let montoTotalDiaSiguiente = 0;
  stockDiaSiguiente.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.tipo_sello.nombre} </td>`);
    mywindow.document.write(`<td> $ ${dato.tipo_sello.valor} </td>`);
    mywindow.document.write(`<td> ${dato.cantidad} </td>`);
    mywindow.document.write(`</tr>`);
    montoTotalDiaSiguiente += dato.tipo_sello.valor * dato.cantidad;
  });

  mywindow.document.write(`</table>`);

  mywindow.document.write(
    `<h4 style="text-align: center">TOTAL: $${montoTotalDiaSiguiente}</h4>`
  );

  mywindow.document.write(
    `<h3 style="text-align: center"><ins> DEPOSITOS DEL RANGO DE FECHAS ${fechaInicio} - ${fechaFin} </ins></h3>`
  );
  mywindow.document.write(`
  <table style="width:100%">
  <tr>
    <th>Fecha del Deposito</th>
    <th>Sucursal B.P.N</th> 
    <th>Nro. Boleta Deposito</th>
    <th>Monto Depositado</th>
  </tr>
  `);

  let montoDepositos = 0;
  depositos.forEach(dato => {
    mywindow.document.write(`<tr>`);
    mywindow.document.write(`<td> ${dato.fecha} </td>`);
    mywindow.document.write(`<td> ${dato.sucursal.nombre} </td>`);
    mywindow.document.write(`<td> ${dato.numBoletaDeposito} </td>`);
    mywindow.document.write(`<td> $ ${dato.importe} </td>`);
    mywindow.document.write(`</tr>`);
    montoDepositos += dato.importe;
  });
  mywindow.document.write(`</table>`);
  mywindow.document.write(
    `<h4 style="text-align: center">TOTAL: $${montoDepositos}</h4>`
  );

  mywindow.document.write('</div>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  mywindow.close();
}
